import { useContext, useMemo } from 'react';
import { TranscriptSpeakersContext } from '@/containers/Transcript/context';
import { CallRole_Utils } from '@/enums';
import type { Transcribe } from '@/types';

export const useTranscriptSpeaker = (speakerIndex: number) => {
  const speakers = useContext(TranscriptSpeakersContext);

  return useMemo(() => {

    const speaker = speakers?.[speakerIndex];
    const displayName = buildTranscriptSpeakerName(speaker, speakerIndex);

    return {
      displayName,
      speaker,
    };
  }, [speakers, speakerIndex]);
};

export function buildTranscriptSpeakerName(speaker: Pick<Transcribe.Speaker, 'name' | 'role'>, speakerIndex: number) {
  const fallback = `Speaker ${speakerIndex + 1}`;

  if (!speaker) return fallback;

  if (speaker.name) return speaker.name;

  if (typeof speaker.role === 'number') {
    return CallRole_Utils.getName(speaker.role);
  }

  return fallback;
}